let KEYS = {
	'IOS': '9ba3bfee-bcbe6cac-0fa5e655-e4fe724c-6cfeaf0a-58db78c9-cedcf724-143e26ea',
	'Android': '89d40ffe-1af07e7f-25a99a75-6fcce88e-9d4a9e73-9f4507c2-e577f081-eeb5c690',
	'webadmin': '9ce28fe8-1861f422-1eadb6d9-fa4e205a-303bf5c3-ce1961fd-e0668096-653e9737',
	'webwallet': 'e412a960-eb9c2798-ba1f973f-41d72f44-eb14e9c7-0bb60991-91f4e4f8-d518ea3e',
	'bnolanding': '0d0f9d67-aa810611-233745a8-75a1a8c6-935ec698-f4ab9fe2-9dd5dfbb-7d8887a3',
	'weboffice': '2dd967f0-d7e0a7af-fc048b62-eef1179c-a2201d9c-f657eba8-9ad5cf4d-8069be28',
	'test': 'd8bf35c0-2895b82d-6db2af15-5179d898-8f67df9a-0b7e3c0f-ecc17826-67662904',
	'bsolanding': '711ca9d2-1f12823b-e421ea19-f07b34bc-730692db-66ce400f-0a1acfd9-2ae57ccc',
	'bblanding': '683b881a-a4d77b71-367b88d0-4d5fdc0d-8c54977b-25cb52e2-2c4b3588-92cbb6e2',
	'bpblanding': '0d2dbcfc-1e20f6b4-8cca8c0d-7abd3108-fe334540-0875ebb7-870bdfb1-6bb03444',
	'bluebull': 'bc40ba1c-6cb811e8-b1b96363-d980692c-2da0e903-8fb7f01f-55fd4adb-b795ce13',
	'blocksalesweb': '21eebafe-cef54a92-69f9c346-8808ce28-ae47b8e7-93336403-f8da9ddb-1de890cf',
	'bnox': '168631e6-76c7219c-c0d6653a-6e6b1895-a25d928d-01847032-287eb760-242aeb53'
}

module.exports = {
	KEYS,
	HEADER_API_KEY: 'x-api-key',
	getClientTypeByKey: function (apiKey) {
		return Object.keys(KEYS).find((key) => { return KEYS[key] === apiKey }) || 'default'
	}
}
